// Generated by purs version 0.15.10
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record_Builder from "../Record.Builder/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var union = /* #__PURE__ */ Record_Builder.union();
var compose = /* #__PURE__ */ Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder);
var insert = /* #__PURE__ */ Record_Builder.insert()();
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_List_Types.applicativeList);
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(Data_List_Types.foldableList)(Data_Monoid.monoidString);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString));
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var EnvLookupError = /* #__PURE__ */ (function () {
    function EnvLookupError(value0) {
        this.value0 = value0;
    };
    EnvLookupError.create = function (value0) {
        return new EnvLookupError(value0);
    };
    return EnvLookupError;
})();
var EnvParseError = /* #__PURE__ */ (function () {
    function EnvParseError(value0) {
        this.value0 = value0;
    };
    EnvParseError.create = function (value0) {
        return new EnvParseError(value0);
    };
    return EnvParseError;
})();
var readValue = function (dict) {
    return dict.readValue;
};
var readEnvNil = {
    readEnv: function (v) {
        return function (v1) {
            return function (v2) {
                return pure(union({}));
            };
        };
    }
};
var readEnv = function (dict) {
    return dict.readEnv;
};
var readEnvCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var insert1 = insert(dictIsSymbol);
    return function (dictReadValue) {
        var readValue1 = readValue(dictReadValue);
        return function () {
            return function (dictReadEnv) {
                var readEnv1 = readEnv(dictReadEnv);
                return function () {
                    return function () {
                        return {
                            readEnv: function (v) {
                                return function (v1) {
                                    return function (env) {
                                        var tail = readEnv1(Type_Proxy["Proxy"].value)(Type_Proxy["Proxy"].value)(env);
                                        var value = readValue1(reflectSymbol(Type_Proxy["Proxy"].value))(env);
                                        var insert2 = function (v2) {
                                            return function (v3) {
                                                if (v2 instanceof Data_Either.Right && v3 instanceof Data_Either.Right) {
                                                    return new Data_Either.Right(compose(insert1(Type_Proxy["Proxy"].value)(v2.value0))(v3.value0));
                                                };
                                                if (v2 instanceof Data_Either.Right && v3 instanceof Data_Either.Left) {
                                                    return new Data_Either.Left(v3.value0);
                                                };
                                                if (v2 instanceof Data_Either.Left && v3 instanceof Data_Either.Right) {
                                                    return new Data_Either.Left(pure1(v2.value0));
                                                };
                                                if (v2 instanceof Data_Either.Left && v3 instanceof Data_Either.Left) {
                                                    return new Data_Either.Left(new Data_List_Types.Cons(v2.value0, v3.value0));
                                                };
                                                throw new Error("Failed pattern match at TypedEnv (line 138, column 5 - line 138, column 81): " + [ v2.constructor.name, v3.constructor.name ]);
                                            };
                                        };
                                        return insert2(value)(tail);
                                    };
                                };
                            }
                        };
                    };
                };
            };
        };
    };
};
var printEnvError = /* #__PURE__ */ (function () {
    var msg = function (v) {
        if (v instanceof EnvLookupError) {
            return "The required variable \"" + (v.value0 + "\" was not specified.");
        };
        if (v instanceof EnvParseError) {
            return "The variable \"" + (v.value0 + "\" was formatted incorrectly.");
        };
        throw new Error("Failed pattern match at TypedEnv (line 67, column 3 - line 68, column 65): " + [ v.constructor.name ]);
    };
    return function (v) {
        if (v instanceof Data_List_Types.Cons && v.value1 instanceof Data_List_Types.Nil) {
            return msg(v.value0);
        };
        return "Multiple environment errors: " + foldMap(function (x) {
            return "\x0a* " + msg(x);
        })(v);
    };
})();
var parseValueString = {
    parseValue: pure2
};
var parseValueNumber = {
    parseValue: Data_Number.fromString
};
var parseValueInt = {
    parseValue: Data_Int.fromString
};
var parseValueChar = {
    parseValue: /* #__PURE__ */ (function () {
        var $96 = map(function (v) {
            return v.head;
        });
        return function ($97) {
            return $96(Data_String_CodeUnits.uncons($97));
        };
    })()
};
var parseValueBoolean = {
    parseValue: function ($98) {
        return (function (v) {
            if (v === "0") {
                return pure2(false);
            };
            if (v === "1") {
                return pure2(true);
            };
            if (v === "false") {
                return pure2(false);
            };
            if (v === "true") {
                return pure2(true);
            };
            return Data_Maybe.Nothing.value;
        })(Data_String_Common.toLower($98));
    }
};
var parseValue = function (dict) {
    return dict.parseValue;
};
var readValueOptional = function (dictParseValue) {
    var parseValue1 = parseValue(dictParseValue);
    return {
        readValue: function (name) {
            return function (env) {
                var v = Foreign_Object.lookup(name)(env);
                if (v instanceof Data_Maybe.Nothing) {
                    return pure(Data_Maybe.Nothing.value);
                };
                if (v instanceof Data_Maybe.Just) {
                    return Data_Either.note(new EnvParseError(name))(map(Data_Maybe.Just.create)(parseValue1(v.value0)));
                };
                throw new Error("Failed pattern match at TypedEnv (line 103, column 5 - line 107, column 60): " + [ v.constructor.name ]);
            };
        }
    };
};
var readValueRequired = function (dictParseValue) {
    var parseValue1 = parseValue(dictParseValue);
    return {
        readValue: function (name) {
            return function (env) {
                return bind(Data_Either.note(new EnvLookupError(name))(Foreign_Object.lookup(name)(env)))((function () {
                    var $99 = Data_Either.note(new EnvParseError(name));
                    return function ($100) {
                        return $99(parseValue1($100));
                    };
                })());
            };
        }
    };
};
var genericEnvError = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new EnvLookupError(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new EnvParseError(x.value0);
        };
        throw new Error("Failed pattern match at TypedEnv (line 53, column 1 - line 53, column 54): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof EnvLookupError) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof EnvParseError) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at TypedEnv (line 53, column 1 - line 53, column 54): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericEnvError)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "EnvLookupError";
    }
}))(/* #__PURE__ */ genericShowConstructor({
    reflectSymbol: function () {
        return "EnvParseError";
    }
})));
var showEnvError = {
    show: function (err) {
        return genericShow(err);
    }
};
var fromEnv = function () {
    return function (dictReadEnv) {
        var readEnv1 = readEnv(dictReadEnv);
        return function (v) {
            return function (env) {
                return map1(Record_Builder.buildFromScratch)(readEnv1(Type_Proxy["Proxy"].value)(Type_Proxy["Proxy"].value)(env));
            };
        };
    };
};
var eqEnvError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof EnvLookupError && y instanceof EnvLookupError) {
                return x.value0 === y.value0;
            };
            if (x instanceof EnvParseError && y instanceof EnvParseError) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
export {
    fromEnv,
    printEnvError,
    EnvLookupError,
    EnvParseError,
    parseValue,
    readValue,
    readEnv,
    eqEnvError,
    genericEnvError,
    showEnvError,
    parseValueBoolean,
    parseValueChar,
    parseValueInt,
    parseValueNumber,
    parseValueString,
    readValueOptional,
    readValueRequired,
    readEnvCons,
    readEnvNil
};
